module.exports = __webpack_public_path__ + "static/media/loading.d5c02aa6.gif";